import { useQuery } from '@tanstack/react-query';
import { apiClient as api } from '@plerionhq/design-system';

export enum Features {
  QuickStart = 'quickstart',
  EnvironmentSuggestion = 'environment-suggestion',
}

export function useFeatureFlags() {
  return useQuery({
    queryKey: ['featureFlags'],
    queryFn: () =>
      api
        .get<Features[]>('/api/base/organization/feature-flags')
        .then((res) => res.data),
    staleTime: 300000,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
